import { FC, memo, ReactElement, useMemo } from 'react';
// Import Types
import type { SubscriptionSectionEnum } from 'enums';
// Import Hooks
import useHasPermission from 'hooks/UseHasPermission';
// Import Components
import BlockedBySubscriptionInfo from 'components/common/BlockedBySubscriptionInfo';

interface Props {
    children: ReactElement;
    subscriptionSection?: SubscriptionSectionEnum;
}

const SectionControl: FC<Props> = ({ children, subscriptionSection }) => {
    const { hasSubscriptionSection } = useHasPermission();

    const isBlockedBySubscription = useMemo(
        () => !hasSubscriptionSection(subscriptionSection),
        [hasSubscriptionSection, subscriptionSection],
    );

    return <BlockedBySubscriptionInfo isBlocked={isBlockedBySubscription}>{children}</BlockedBySubscriptionInfo>;
};

export default memo(SectionControl);
